import { Badge, Space, Typography, Tag } from "antd";
import { Button } from "antd";
// import { PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { formatMoney } from "../../../utils/util";
import { EditableRow, EditableCell } from "../../../components/table/TableEditAble";

import { docLinkRender } from "../../../components/table/DocLink";
/** export component for edit table */
export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

export const accessColumn = ({ handleEdit, handleDelete, handleView }) => [
  {
    title: "รหัสลูกค้า",
    key: "cuscode",
    dataIndex: "cuscode",
    align: "left",
    width: 110,
    sorter: (a, b) => (a?.cuscode || "").localeCompare(b?.cuscode || ""),
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดูข้อมูลลูกค้า"),
  },
  {
    title: "ชื่อลูกค้า",
    dataIndex: "cusname",
    key: "cusname",
    width: "20%",
    sorter: (a, b) => (a?.cusname || "").localeCompare(b?.cusname || ""),
  },
  {
    title: "ที่อยู่",
    dataIndex: "idno",
    key: "idno",
    width: "28%",
    sorter: (a, b) => (a?.idno || "").localeCompare(b?.idno || ""),
    render: (_, head) => (
      <Typography.Text>
        {head.idno && `${head.idno}`}
        {head.road && ` ${head.road}`}
        {head.subdistrict && ` ${head.subdistrict}`}
        {head.district && ` ${head.district}`}
        {head.province && ` ${head.province}`}
        {head.zipcode && ` ${head.zipcode}`}
        {head.tel && ` ${head.tel}`}
      </Typography.Text>
    ),
  },
  {
    title: "ประเทศ",
    dataIndex: "country",
    key: "country",
    sorter: (a, b) => (a?.country || "").localeCompare(b?.country || ""),
    width: 140,
  },
  {
    title: "สถานะ",
    dataIndex: "active_status",
    key: "active_status",
    width: 120,
    sorter: (a, b) =>
      (a?.active_status || "").localeCompare(b?.active_status || ""),
    render: (data) => (
      <div>
        {data === "เปิดการใช้งาน" ? (
          <Badge status="success" text="เปิดการใช้งาน" />
        ) : (
          <Badge status="error" text="ปิดการใช้การ" />
        )}
      </div>
    ),
  },
  {
    title: "วันที่สร้าง",
    dataIndex: "created_date",
    key: "created_date",
    width: 120,
    sorter: (a, b) =>
      (a?.created_date || "").localeCompare(b?.created_date || ""),
    render: (v) => dayjs(v).format("DD/MM/YYYY"),
  },
  {
    title: "Action",
    key: "operation",
    width: "100px",
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(record)}
        />
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
      </Space>
    ),
  },
];

export const columnsParametersEditable = (handleSave,{handleRemove, readOnly = false} ) =>{
  const col = ProductColumn({handleRemove, readOnly});
  return col.map((col, ind) => {
      if (readOnly || !col.editable) return col;

      return {
          ...col,
          onCell: (record) => {
            const extra = {};
            if (col.type === "date" && record[col.dataIndex]) {
              extra.initialValue = dayjs(record[col.dataIndex]);
            }
            return {
              record,
              editable: col.editable,
              dataIndex: col.dataIndex,
              title: col.title,
              type: col?.type || "input",
              handleSave,
              ...extra,
            }
          },
      };
  });
}

export const ProductColumn = ({ handleRemove, readOnly = false }) => [
  {
    title: "ลำดับ",
    dataIndex: "ind",
    key: "ind",
    align: "center",
    width: "5%",
    render: (im, rc, index) => <>{index + 1}</>,
  },
  {
    title: "ชนิด",
    key: "item_type",
    dataIndex: "item_type",
    width: "6%",
    align: "center",
    render: (v) =>
      (v || "PG") === "FG" ? (
        <Tag color="purple">FG</Tag>
      ) : (
        <Tag color="blue">PG</Tag>
      ),
  },
  {
    title: "รหัสสินค้า",
    key: "pg_code",
    dataIndex: "pg_code",
    width:"14%",
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "pg_name",
    key: "pg_name",
    width:"15%",
  },
  {
    title: "Customer PG Name",
    dataIndex: "pg_stname_cus",
    key: "pg_stname_cus",
    width:"15%",
  },
  {
    title: "PG Invoice Name",
    dataIndex: "pg_ivname",
    key: "pg_ivname",
    width:"15%",
  },
  {
    title: "Price",
    dataIndex: "price",
    key: "price",
    width: "10%",
    align: "right",
    className: "!pe-3",
    editable: true,
    required: true,
    type: "number",
    render: (_, rec) => <>{formatMoney(Number(rec?.price || 0), 2, 2)}</>,
  },
  {
    title: "วันที่ของราคา",
    dataIndex: "price_date",
    key: "price_date",
    align: "center",
    width: "12%",
    editable: true,
    required: false,
    type: "date",
    render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
  },
  ...(readOnly
    ? []
    : [
        {
          title: "ตัวเลือก",
          align: "center",
          key: "operation",
          dataIndex: "operation",
          render: (_, record, idx) => handleRemove(record),
          width: "4%",
          fixed: "right",
        },
      ]),
];

export const customer = {
  id: null,
  cuscode: null,
  cusname: null,
  prename: null,
  idno: null,
  road: null,
  subdistrict: null,
  district: null,
  province: null,
  zipcode: null,
  country: null,
  delidno: null,
  delroad: null,
  delsubdistrict: null,
  deldistrict: null,
  delprovince: null,
  delzipcode: null,
  delcountry: null,
  tel: null,
  fax: null,
  taxnumber: null,
  email: null,
  active_status: "Y",
  /* รูปแบบวันที่บนใบ Invoice — ว่าง = ใช้ค่าเริ่มต้น DD/MM/YYYY */
  date_format: null,
};

/* รูปแบบวันที่ที่ใช้บนใบ Invoice (token ของ dayjs) */
export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const DATE_FORMAT_OPTIONS = ["DD/MM/YYYY", "YYYY/MM/DD"];
